import { useCallback, useReducer } from "react";
import { ReportTypeEnum } from "../../services/reporting-data-service/ReportScheduleModels";
import { ViewOptionStateEnum } from "../contextual-app-bar/ViewOptionStateEnum";


type ScheduledReportsListStateType = {
    viewOptionState: ViewOptionStateEnum;
    filterText: string;
    scheduledReportType: ReportTypeEnum;
    isDirty: boolean;
};

export const defaultState: ScheduledReportsListStateType = {
    viewOptionState: ViewOptionStateEnum.Default,
    filterText: '',
    scheduledReportType: ReportTypeEnum.None,
    isDirty: false,
};


enum ScheduledReportsListStateActionEnum {
    FilterTextChanged = 'SCHEDULED_REPORT_LIST_FILTER_TEXT_CHANGED',
    ReportTypeChanged = 'SCHEDULED_REPORT_LIST_REPORT_TYPE_CHANGED',
    Reset = 'SCHEDULED_REPORT_LIST_RESET_CHANGED'
}


type ScheduledReportsListStateActionType = {
    type: ScheduledReportsListStateActionEnum.FilterTextChanged;
    payload: string;
} | {
    type: ScheduledReportsListStateActionEnum.ReportTypeChanged;
    payload: ReportTypeEnum;
} | {
    type: ScheduledReportsListStateActionEnum.Reset;
    payload: void;
};


const optionsChanged = (newState: ScheduledReportsListStateType, 
    defaultState: ScheduledReportsListStateType) => 
        newState.filterText !== defaultState.filterText ||
        newState.scheduledReportType !== defaultState.scheduledReportType;


function reducer(state: ScheduledReportsListStateType, action: ScheduledReportsListStateActionType): ScheduledReportsListStateType {

    const copy = { ...state };
    switch (action.type) {

        case ScheduledReportsListStateActionEnum.Reset:
            return {...defaultState};

        case ScheduledReportsListStateActionEnum.FilterTextChanged:
            copy.filterText = action.payload;

            copy.viewOptionState = optionsChanged(copy, defaultState) ? 
                                    ViewOptionStateEnum.Changed : 
                                    ViewOptionStateEnum.Default;

            return copy;

        case ScheduledReportsListStateActionEnum.ReportTypeChanged:
            copy.scheduledReportType = action.payload;

            copy.viewOptionState = optionsChanged(copy, defaultState) ? 
                                    ViewOptionStateEnum.Changed : 
                                    ViewOptionStateEnum.Default;

            return copy;
    
        default: 
            return {
                ...state
            };
    }
}

export default function useScheduledReportsListState() {
    const [state, dispatch] = useReducer(reducer, defaultState);

    const setFilterText = useCallback((value: string) => dispatch({
        type: ScheduledReportsListStateActionEnum.FilterTextChanged,
        payload: value
    }), []);

    const setScheduledReportType = useCallback((value: ReportTypeEnum) => dispatch({
        type: ScheduledReportsListStateActionEnum.ReportTypeChanged,
        payload: value
    }), []);

    

    const resetState = useCallback(() => dispatch({
        type: ScheduledReportsListStateActionEnum.Reset,
        payload: undefined
    }), []);


    return {
        state,
        setFilterText,
        setScheduledReportType,
        resetState
    };
}    
